export const maxWidth = '664px';

// this list comes from papyrus, both must be in sync
export const SUPPORTED_MIME_TYPES = 'image/png, image/jpeg';
export const FILE_SIZE_LIMIT_MB = 20;

export const ROOT_IDV_PATH = '/account-verify';
